<template>
  <Modal 
    :id="'cmp-catalog-licence-add-account'" 
    @cancelled="onCancel"
  >
    <template slot="header">Export {{$t('release')}} </template>
    <template slot="body">
      <div class="form-group">

        <Dropdown
           :id="'label'"
           class="m2"
           :options="labelsTV"
           :selected="
              labelsTV.find(
                (x) => x.value == label
              )
            "
            :placeholder="$t('labels')"
           box
           deselect
           @selectedChange="(e) => onDropdownChange('label', e)"
        ></Dropdown>    

        <TextField
          class="m1"
          :id="'start_date'"
     
          v-bind="textFieldConfig"
         
          :value="start_date"
          :placeholder="$t('start_date')"
          type="date"
          @valuechanged="onTextFieldValueChange"
          @validated="onValidation"
        />

        <TextField
          class="m1"
          :id="'end_date'"
          
          v-bind="textFieldConfig"
        
          :value="end_date"
           type="date"
          :placeholder="$t('end_date')"
          @valuechanged="onTextFieldValueChange"
          
        />

         
      </div>
    </template>
    <template slot="options">
      
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >{{$t('cancel')}}</button>
      <button
        class="dt-button v1 with-ico"
         :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="exportRelease"
      >
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';


import {
  createTV,
  tv,
} from "../../../../models/text-value.model";
import { releaseService } from '../../services/releases/releases.services';
import FileDownload from "js-file-download";
export default {
  components: {
    Modal,
  },
  props: {
    
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
      },

      start_date:'',
      end_date:'',
      label:null,
      labels:[],
      validationResult: {},
    };
  },
  mounted:async function() {
     const  res=await releaseService.releaseReportModal(); 
     console.log("WERE",res);

     this.labels=res.data.labels
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
    labelsTV:function(params) {
      return createTV(this.labels,"label_name","label_id");
    },

  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onDropdownChange: function (name, value) {      // <-- Normal Form Handling Methods
            this[name]=value.value
            console.log(name,value,this[name])

    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this[key]=value
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    exportRelease:async function(e) {
      console.log()
      console.log({start_date:this.start_date , end_date:this.end_date, label:this.label});
      const payload={start_date:this.start_date , end_date:this.end_date, label:this.label}
      const resData=await releaseService.filterReleaseReport({start_date:this.start_date , end_date:this.end_date, label_id:this.label});
      
         FileDownload(resData.data, "releases.xlsx");

      console.log(resData);
      
      //this.$emit('exportRelease', {start_date:this.start_date , end_date:this.end_date, label:this.label});
    
    },
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-catalog-licence-add-account {
}
</style>